import type { FlightPlayerScoresFragment } from '../../../__generated__/hooks'
import { blockSideTotals } from '../helpers'

/**
 * The side's result, spanning the columns that produced it.
 *
 * Best ball's four columns are four players, and the round is between two
 * sides — so the per-player Totalt above is background, not the result. It
 * used to sit under the card as a note, which read as a remark about the
 * scorecard rather than as the scorecard's own bottom line.
 *
 * A spanned cell rather than the number repeated in each member's column:
 * one figure covering a pair says the pair is the entrant, where the same
 * figure printed twice says each of them scored it.
 */
const SideTotalRow = ({
  sides,
  block,
  showStableford,
}: {
  sides: { id: string; name: string; entries: FlightPlayerScoresFragment[] }[]
  block: { fromHole: number; toHole: number; format: string }
  showStableford?: boolean
}) => (
  <tr
    className="border-t-2 border-green-900"
    style={{ background: 'var(--green-50)' }}
  >
    <th
      scope="row"
      className="text-left px-2 py-2 align-middle"
      style={{ background: 'var(--green-50)' }}
    >
      <div
        className="font-display text-[11px] font-extrabold text-green-900"
        style={{ letterSpacing: 'var(--ls-caps)', textTransform: 'uppercase' }}
      >
        Laget
      </div>
      <div className="font-mono num text-[10px] text-ink-500 leading-tight mt-0.5">
        best ball
      </div>
    </th>
    {sides.map((side) => {
      const totals = blockSideTotals(side.entries, block)
      return (
        <td
          key={side.id}
          colSpan={side.entries.length}
          className="text-center px-1 py-2 font-mono num leading-tight border-l border-ink-200"
        >
          <div className="font-bold text-green-900 text-base">
            {totals.gross || '—'}
          </div>
          <div className="text-[10px] text-ink-500 mt-0.5">
            {showStableford ? `${totals.points} p` : `${totals.net} netto`}
          </div>
        </td>
      )
    })}
  </tr>
)

export default SideTotalRow
